import React from "react";
import "./About.css";

const About = () => {
  return (
    <section id="about">
      <h2>About me</h2>

      <div className="container about__container">
        <div className="about__card-wrapper">
          <ul className="about__me__points">
            <li>
              I'm Nigerian & Spanish, born in London, UK. I grew up between
              London and Madrid.
            </li>
            <li>
              I speak English, Spanish, Portuguese, French, and currently learning
              Tagalog.
            </li>
            <li>
              Outside of coding I enjoy tennis, samba, travelling, great food and blue skies.
            </li>
            <li>
              A random talent I have is that I know how to clap with one hand...
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default About;
